import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpecializariComponent } from './specializari.component';
import { AddSpecializariComponent } from './add-specializari/add-specializari.component';
import { EditSpecializariComponent } from './edit-specializari/edit-specializari.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
    declarations: [
        SpecializariComponent,
        AddSpecializariComponent,
        EditSpecializariComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [SpecializariComponent]
})
export class SpecializariModule { }
